import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=21e9af7c&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=21e9af7c&scoped=true&lang=less&"
import style1 from "./Order.vue?vue&type=style&index=1&id=21e9af7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e9af7c",
  null
  
)

export default component.exports